import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "header-title-text d-flex align-center" };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "delivery-setting-edit-container" };
import CardSection from '@/components/Common/CardSection.vue';
import WorkInfo from '@V/WorkerManagement/WorkerDetail/WorkInfo.vue';
import WorkInfoEdit from '@/views/WorkerManagement/WorkerEdit/WorkInfo.vue';
import PrivateInfo from '@V/WorkerManagement/WorkerDetail/PrivateInfo.vue';
import PrivateInfoEdit from '@/views/WorkerManagement/WorkerEdit/PrivateInfo.vue';
import DeliverySetting from '@V/WorkerManagement/WorkerDetail/DeliverySetting.vue';
import DeliverySettingEdit from '@/views/WorkerManagement/WorkerEdit/DeliverySetting.vue';
import { computed, ref, toRefs, watch, } from 'vue';
import { useRoute } from 'vue-router';
import { workerService } from '@/services';
import { i18n } from '@/locales';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
import WorkerVM from '@/view-model/worker-management/WorkerVM';
import { modalWorkerInfoActionType } from '@/vuex-store/modal-worker-info/actions';
import { workerActionType } from '@/vuex-store/worker/actions';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        propsWorkerCode: { default: '' }
    },
    setup(__props, { expose: __expose }) {
        const route = useRoute();
        const workerDetail = ref();
        const isEdit = ref({
            workInfo: false,
            privateInfo: false,
            deliverySetting: false,
        });
        const formRefWorkInfo = ref(null);
        const formRefPrivateInfo = ref(null);
        const formRefDeliverySetting = ref(null);
        const updatedData = ref({
            workInfo: {},
            privateInfo: {},
            deliverySetting: {},
        });
        const props = __props;
        const { propsWorkerCode, } = toRefs(props);
        const workerCode = computed(() => route.params.workerCode || propsWorkerCode.value);
        const convertSubmitDataToPayload = (list) => {
            const a = list.reduce((acc, [key, value,]) => {
                if (key === 'workerRegDate') {
                    acc[key] = value.replace(/-/g, '');
                    return acc;
                }
                if (key === 'workerLeaveDate') {
                    acc[key] = value.replace(/-/g, '');
                    return acc;
                }
                if (key === 'workTime') {
                    const { on, off } = value;
                    acc[key] = on.replace(':', '') + off.replace(':', '');
                    return acc;
                }
                acc[key] = value;
                return acc;
            }, {});
            return a;
        };
        /**
         * 라이더 상세정보 조회
         */
        const getWorkerDetail = async () => {
            // 레이어 무시 바로 적용.
            const response = await workerService.getWorker({
                workerCode: workerCode.value,
            });
            workerDetail.value = new WorkerVM(response.data);
        };
        /**
         * 폼 데이터 설정
         */
        const setFormData = (key, data) => {
            updatedData.value[key] = data;
        };
        /**
         * 창 닫기 버튼 클릭 핸들러
         */
        const handleClickCloseBtn = () => {
            if (isEdit.value.workInfo
                || isEdit.value.privateInfo
                || isEdit.value.deliverySetting) {
                vuexStore.dispatch(snackbarActionType.showError, '수정 중에는 닫을 수 없습니다.');
                return false;
            }
            // 팝업일 경우
            if (window.opener) {
                window.close();
                // 다이얼로그일 경우
            }
            else {
                vuexStore.dispatch(modalWorkerInfoActionType.setIsOpenModalWorkerInfo, 0);
                vuexStore.dispatch(workerActionType.clearWorker);
            }
            return true;
        };
        /**
         * 수정 버튼 클릭 핸들러
         */
        const handleClickEdit = (key) => {
            isEdit.value[key] = true;
        };
        /**
         * 취소 버튼 클릭 핸들러
         */
        const handleClickCancel = (key) => {
            isEdit.value[key] = false;
        };
        /**
         * 저장 버튼 클릭 핸들러
         * @param key 저장 카드 타입
         */
        const handleClickSave = async (key) => {
            // 여기
            const { valid } = await {
                workInfo: formRefWorkInfo.value,
                privateInfo: formRefPrivateInfo.value,
                deliverySetting: formRefDeliverySetting.value,
            }[key].validate();
            if (!valid) {
                return vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.form_validation_error'));
            }
            try {
                const submitDataList = Object.entries(updatedData.value[key]);
                const payload = convertSubmitDataToPayload(submitDataList);
                // 레이어 무시 바로 적용
                await workerService.putWorkerDetail({
                    code: workerCode.value,
                    newData: payload,
                });
                // 수정 성공의 경우
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('views.snackbar.worker_modify_complete'));
                isEdit.value[key] = false;
                getWorkerDetail();
            }
            catch (error) {
                console.log('[workerEdit error]', error);
                vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.unknown_error'));
            }
            return true;
        };
        watch(() => workerCode.value, (v) => {
            if (v) {
                getWorkerDetail();
            }
        }, {
            immediate: true,
        });
        __expose({
            handleClickCloseBtn,
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card = _resolveComponent("v-card");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createBlock(_component_v_card, { class: "card dialog" }, {
                default: _withCtx(() => [
                    _createCommentVNode(" 우상단 닫기 버튼 "),
                    _createVNode(_component_v_btn, {
                        icon: "mdi-close",
                        variant: "text",
                        class: "btn-close",
                        onClick: handleClickCloseBtn
                    }),
                    _createCommentVNode(" Header "),
                    _createVNode(_component_v_card_title, { class: "dialog__head d-flex" }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, [
                                _createVNode(_component_v_icon, { class: "mr-2 brg-color-blue-700" }, {
                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                        _createTextVNode(" mdi-moped ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [12]
                                }),
                                _cache[13] || (_cache[13] = _createElementVNode("span", null, " 라이더 상세정보 ", -1 /* CACHED */))
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider),
                    _createCommentVNode(" Body "),
                    _createVNode(_component_v_card_text, { class: "dialog__body card-list" }, {
                        default: _withCtx(() => [
                            _createVNode(CardSection, { title: "근무 정보" }, {
                                titleContent: _withCtx(() => [
                                    (!isEdit.value.workInfo)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "option-ctrl-area",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (handleClickEdit('workInfo')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { small: "" }, {
                                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                        _createTextVNode(" mdi-pencil-outline ")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [14]
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })), [
                                            [
                                                _directive_btn_style,
                                                void 0,
                                                "config",
                                                {
                                                    info: true,
                                                    outlined: true,
                                                    "size-m": true
                                                }
                                            ]
                                        ])
                                        : _createCommentVNode("v-if", true),
                                    (isEdit.value.workInfo)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "option-ctrl-area mr-1",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (handleClickCancel('workInfo')))
                                            }, {
                                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                    _createElementVNode("span", null, "취소", -1 /* CACHED */)
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [15]
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        info: true,
                                                        outlined: true,
                                                        "size-m": true
                                                    }
                                                ]
                                            ]),
                                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "option-ctrl-area",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (handleClickSave('workInfo')))
                                            }, {
                                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                    _createElementVNode("span", null, "저장", -1 /* CACHED */)
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [16]
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        primary: true,
                                                        "size-m": true
                                                    }
                                                ]
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                default: _withCtx(() => [
                                    (!isEdit.value.workInfo)
                                        ? (_openBlock(), _createBlock(WorkInfo, {
                                            key: 0,
                                            detail: workerDetail.value
                                        }, null, 8 /* PROPS */, ["detail"]))
                                        : _createCommentVNode("v-if", true),
                                    (isEdit.value.workInfo)
                                        ? (_openBlock(), _createBlock(_component_v_form, {
                                            key: 1,
                                            ref_key: "formRefWorkInfo",
                                            ref: formRefWorkInfo
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(WorkInfoEdit, {
                                                    "worker-detail": workerDetail.value,
                                                    "head-col": 5,
                                                    onSetFormData: _cache[3] || (_cache[3] = ($event) => (setFormData('workInfo', $event)))
                                                }, null, 8 /* PROPS */, ["worker-detail"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 512 /* NEED_PATCH */))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(CardSection, { title: "차량면허 및 보험 정보" }, {
                                titleContent: _withCtx(() => [
                                    (!isEdit.value.privateInfo)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "option-ctrl-area",
                                            onClick: _cache[4] || (_cache[4] = ($event) => (handleClickEdit('privateInfo')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { small: "" }, {
                                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                        _createTextVNode(" mdi-pencil-outline ")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [17]
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })), [
                                            [
                                                _directive_btn_style,
                                                void 0,
                                                "config",
                                                {
                                                    info: true,
                                                    outlined: true,
                                                    "size-m": true
                                                }
                                            ]
                                        ])
                                        : _createCommentVNode("v-if", true),
                                    (isEdit.value.privateInfo)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "option-ctrl-area mr-1",
                                                onClick: _cache[5] || (_cache[5] = ($event) => (handleClickCancel('privateInfo')))
                                            }, {
                                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                    _createElementVNode("span", null, "취소", -1 /* CACHED */)
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [18]
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        info: true,
                                                        outlined: true,
                                                        "size-m": true
                                                    }
                                                ]
                                            ]),
                                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "option-ctrl-area",
                                                onClick: _cache[6] || (_cache[6] = ($event) => (handleClickSave('privateInfo')))
                                            }, {
                                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                    _createElementVNode("span", null, "저장", -1 /* CACHED */)
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [19]
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        primary: true,
                                                        "size-m": true
                                                    }
                                                ]
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                default: _withCtx(() => [
                                    (!isEdit.value.privateInfo)
                                        ? (_openBlock(), _createBlock(PrivateInfo, {
                                            key: 0,
                                            detail: workerDetail.value
                                        }, null, 8 /* PROPS */, ["detail"]))
                                        : _createCommentVNode("v-if", true),
                                    (isEdit.value.privateInfo)
                                        ? (_openBlock(), _createBlock(_component_v_form, {
                                            key: 1,
                                            ref_key: "formRefPrivateInfo",
                                            ref: formRefPrivateInfo
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(PrivateInfoEdit, {
                                                    "worker-detail": workerDetail.value,
                                                    "head-col": 5,
                                                    onSetFormData: _cache[7] || (_cache[7] = ($event) => (setFormData('privateInfo', $event)))
                                                }, null, 8 /* PROPS */, ["worker-detail"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 512 /* NEED_PATCH */))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(CardSection, { title: "배달설정" }, {
                                titleContent: _withCtx(() => [
                                    (!isEdit.value.deliverySetting)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "option-ctrl-area",
                                            onClick: _cache[8] || (_cache[8] = ($event) => (handleClickEdit('deliverySetting')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { small: "" }, {
                                                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                        _createTextVNode(" mdi-pencil-outline ")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [20]
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })), [
                                            [
                                                _directive_btn_style,
                                                void 0,
                                                "config",
                                                {
                                                    info: true,
                                                    outlined: true,
                                                    "size-m": true
                                                }
                                            ]
                                        ])
                                        : _createCommentVNode("v-if", true),
                                    (isEdit.value.deliverySetting)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "option-ctrl-area mr-1",
                                                onClick: _cache[9] || (_cache[9] = ($event) => (handleClickCancel('deliverySetting')))
                                            }, {
                                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                    _createElementVNode("span", null, "취소", -1 /* CACHED */)
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [21]
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        info: true,
                                                        outlined: true,
                                                        "size-m": true
                                                    }
                                                ]
                                            ]),
                                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "option-ctrl-area",
                                                onClick: _cache[10] || (_cache[10] = ($event) => (handleClickSave('deliverySetting')))
                                            }, {
                                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                    _createElementVNode("span", null, "저장", -1 /* CACHED */)
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [22]
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        primary: true,
                                                        "size-m": true
                                                    }
                                                ]
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                default: _withCtx(() => [
                                    (!isEdit.value.deliverySetting)
                                        ? (_openBlock(), _createBlock(DeliverySetting, {
                                            key: 0,
                                            detail: workerDetail.value
                                        }, null, 8 /* PROPS */, ["detail"]))
                                        : _createCommentVNode("v-if", true),
                                    (isEdit.value.deliverySetting)
                                        ? (_openBlock(), _createBlock(_component_v_form, {
                                            key: 1,
                                            ref_key: "formRefDeliverySetting",
                                            ref: formRefDeliverySetting
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_5, [
                                                    _createVNode(DeliverySettingEdit, {
                                                        "worker-detail": workerDetail.value,
                                                        "head-col": 5,
                                                        onSetFormData: _cache[11] || (_cache[11] = ($event) => (setFormData('deliverySetting', $event)))
                                                    }, null, 8 /* PROPS */, ["worker-detail"])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 512 /* NEED_PATCH */))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
